import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { FileUpload } from "./FileUpload";
import { FileUploadUser } from "../types/auth";
import "./Dashboard.css";

export const Dashboard: React.FC = () => {
  const auth = useAuth();
  const [uploadHistory, setUploadHistory] = useState<string[]>([]);

  const handleUploadSuccess = (filename: string) => {
    setUploadHistory((prev) => [filename, ...prev]);
  };

  const handleUploadError = (error: string) => {
    console.error("Upload error:", error);
  };

  const handleLogout = () => {
    auth.signoutRedirect();
  };

  // Convert OIDC user to FileUpload user format for compatibility
  const fileUploadUser: FileUploadUser = {
    uid: auth.user?.profile?.sub || "",
    email: auth.user?.profile?.email,
    displayName:
      auth.user?.profile?.name || auth.user?.profile?.preferred_username,
    photoURL: auth.user?.profile?.picture,
    token: auth.user?.access_token,
  };

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <div className="header-content">
          <h1>ERP Uploader</h1>
          <div className="user-info">
            <span className="welcome-text">
              Welcome,{" "}
              {auth.user?.profile?.name ||
                auth.user?.profile?.preferred_username ||
                auth.user?.profile?.email ||
                "User"}
              !
            </span>
            <button className="logout-btn" onClick={handleLogout}>
              Sign Out
            </button>
          </div>
        </div>
      </header>

      <main className="dashboard-main">
        <div className="upload-section">
          <h2>Upload File</h2>
          <p className="section-description">
            Select a file to upload to the ERP system. The file will be
            processed and stored securely.
          </p>

          <FileUpload
            user={fileUploadUser}
            onUploadSuccess={handleUploadSuccess}
            onUploadError={handleUploadError}
          />
        </div>

        {uploadHistory.length > 0 && (
          <div className="history-section">
            <h3>Recent Uploads</h3>
            <div className="upload-history">
              {uploadHistory.map((filename, index) => (
                <div key={index} className="history-item">
                  <span className="file-icon">📄</span>
                  <span className="filename">{filename}</span>
                  <span className="upload-time">Just now</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </main>

      <footer className="dashboard-footer">
        <p>&copy; 2024 ERP Uploader. All rights reserved.</p>
      </footer>
    </div>
  );
};
